<template>
    <list-page-shell title="驳回单">
        <order-workbench
            :show-title="false"
            :show-create-button="false"
            :extra-query-params="{ reject_resubmit_list: 1 }"
            :list-table-variant="'tax_cleared'"
        />
    </list-page-shell>
</template>

<script>
import ListPageShell from '../components/ListPageShell.vue';
import OrderWorkbench from '../components/OrderWorkbench.vue';

export default {
    name: 'RejectResubmitList',
    components: {
        ListPageShell: ListPageShell,
        OrderWorkbench: OrderWorkbench
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/RejectResubmitList.vue